module.exports = __webpack_public_path__ + "img/P150T_weapon_77.37ad3622.png";